import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/flight-supplier-check-list',
      name: 'admin-flight-supplier-check-list',
      component: () => import(/* webpackChunkName: "page-admin-supplier-management-flight-supplier-check-list" */ `@/page/admin/supplier-management/flight-supplier-check-list/1.0.0/index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "机票供应商审核列表"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "供应商管理"
                                        },
                                        {
                                                  name: "机票供应商审核列表"
                                        }
                              ]
                    }
          }
},
    },
  ],
};

